<template>
  <div id="app" v-title data-title="卡丁生活">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
}
</script>

<style>
  #app {
   /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px; */
  }
  body{
    margin: 0px;
    padding: 0px;
    border: 0px;
  }
  .el-input__inner:focus{
    border:1px solid #FD8723;
  }
  body{
    background-color: #f8f8f8;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue